import { ScreenOrientation } from '@capacitor/screen-orientation'
import { isNative } from './isNative'
import { ScreenOrientation as ScreenOrientationPref } from '../../services/api.types'

export async function applyScreenOrientation(pref: ScreenOrientationPref): Promise<void> {
  if (!isNative()) return
  try {
    if (pref === ScreenOrientationPref.PORTRAIT) {
      await ScreenOrientation.lock({ orientation: 'portrait' })
    } else {
      await ScreenOrientation.unlock()
    }
  } catch {
    // The plugin can throw on iPad / Stage Manager — ignore.
  }
}
